import { Dimensions, DIMENSION_TEMPLATE, Piece, Shipment, Value } from "../interfaces";

import { formatDate } from '@angular/common';
import { UserService } from "../services/user.service";

export class Wrapper {

  private dimensions = DIMENSION_TEMPLATE;

  private los: Piece | Shipment;

  protected userService: UserService;

  constructor(los: Piece | Shipment, dimensions: Dimensions, userService: UserService) {
    this.los = los;
    this.dimensions = dimensions;
    this.userService = userService;
  }

  protected valueString(value: Value, digits?: number) {
    if (digits) {
      return `${value.value.toFixed(digits)} ${value.unit}`;
    }
    return `${value.value} ${value.unit}`;
  }

  get id(): string {
    return this.los['@id'];
  }

  get idAbbrev(): string {
    let parts = this.id.split('/');
    return `…${parts[parts.length - 1]}`;
  }

  get height(): string {
    return this.valueString(this.dimensions.height);
  }

  get length(): string {
    return this.valueString(this.dimensions.length);
  }

  get width(): string {
    return this.valueString(this.dimensions.width);
  }

  get volume(): string {
    return this.valueString(this.dimensions.volume, 2);
  }

  get dimension(): string {
    return `${this.height}×${this.width}×${this.length}`;
  }


  formatDate(date: string | Date | number): string {
    let res = '';
    if (date instanceof String || (date !== '')) {
      res = formatDate(date, 'yyyy-MM-dd HH:mm', 'en') ?? '';
    }
    return res;
  }
}
